<template>
    <v-container fluid>
        <v-row>
            <v-col 
                style="display: flex; align-content: center; align-items: center;"
                cols="6"
                lg="10"
                md="8"
                sm="6"
            >
                <h3>Activities</h3>
            </v-col>
            <v-col 
                style="text-align: right;"
                cols="6"
                lg="2"
                md="4"
                sm="6"
            >
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            dark
                            v-bind="attrs"
                            v-on="on"
                            @click="exportExcel()"
                            style="margin-right: 20px;"
                        >
                            <span>Export to Excel</span>
                        </v-btn>
                    </template>
                    <span>Export to Excel</span>
                </v-tooltip>

                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            v-bind="attrs"
                            v-on="on"
                            :to="{ name: 'actionsForm', params: {id: 0} }"
                        >
                            New Activity
                        </v-btn>
                    </template>
                    <span>New Activity</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-form @submit.prevent="getRegisters">
                    <v-text-field
                        v-model="filter.fastSearch"
                        label="Quick Search"
                        prepend-inner-icon="mdi mdi-magnify"
                        single-line
                        outlined
                        @click:prepend-inner="getRegisters"
                        dense
                    ></v-text-field>
                </v-form>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="filteredSearch"
                    :options.sync="options"
                    :loading="loading"
                    :items-per-page="10"
                    no-data-text="No Record Found"
                >
                    <template v-slot:item.statusDescription="{ item }">
                        <v-chip
                            :color="getStatusColor(item.status)"
                            outlined
                            dark
                            small
                        >
                            {{ item.statusDescription }}
                        </v-chip>
                    </template>

                    <template v-slot:item.action="{item}">
                        <ActionList 
                            :id="item.id" 
                            :link="'actionsForm'"
                            :showButtons="{
                                edit: true,
                                clone: true,
                                cancel: item.status === 1 ? true : false,
                                active: item.status === 0 ? true : false
                            }"
                            @confirmCancel="confirmCancel"
                            @confirmActive="confirmActive"
                            @confirmClone="confirmClone" />
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <ActionDialog 
            v-on:methodConfirmToCall="dialog.methodConfirm"
            :showDialog.sync="dialog.show"
            :headerTitle="dialog.headerText"
            :bodyText="dialog.bodyText"
            :params="dialog.params"
        />

    </v-container>
</template>

<script>
    import Helpers from '@/utilities/Helpers';
    import ActionList from "@/components/Layout/ActionList";
    import ActionDialog from "@/components/Layout/ActionDialog";
    import { URL_EXPORT_ACTIONS } from "@/utilities/Enums";

    export default ({

        components: {
            ActionList: ActionList,
            ActionDialog: ActionDialog
        },

        mixins: [Helpers],

        data: () => ({

            loading: false,

            filter: {
                fastSearch: ''
            },

            dialog: {
                show: false,
                headerText: "",
                bodyText: "",
                methodConfirm: ( () => {} ),
                params: null
            },

            headers: [
                { text: "ID", value: "id", sortable: true, size: "5%" },
                { text: "Created On", value: "dateRegisterFormatted", sortable: true },
                { text: "Panel", value: "panelDescription", sortable: true },
                { text: "Stage", value: "stageDescription", sortable: true },
                { text: "Name", value: "labelName", sortable: true },
                { text: "Project Type", value: "projectTypeDescription", sortable: true },
                { text: "Quick Access", value: "quickAccessMenuDescription", sortable: true },
                { text: "Export PDF", value: "exportPDFDescription", sortable: true },
                { text: "Required Signature", value: "requiredSignDescription", sortable: true },
                { text: "Photos Required", value: "photosRequiredDescription", sortable: true },
                { text: "Status", value: "statusDescription", sortable: true },
                { text: "Actions", value: "action", sortable: false, align: "center" }
            ],

            statusId: 0,

            options: { rowsPerPage: 10, page: 1 },

            listActions: [],

            URL_EXPORT_ACTIONS
        }),

        computed: {

            filteredSearch: function() {
                return this.listActions.filter((actionFilter) => {
                    
                    const filter = this.filter.fastSearch.toLowerCase();

                    const dateRegisterFormatted = actionFilter.dateRegisterFormatted.toLowerCase().match(filter)
                    const panelDescription = actionFilter.panelDescription.toLowerCase().match(filter)
                    const stageDescription = actionFilter.stageDescription.toLowerCase().match(filter)
                    const labelName = actionFilter.labelName.toLowerCase().match(filter)
                    const quickAccessMenuDescription = actionFilter.quickAccessMenuDescription.toLowerCase().match(filter)
                    const statusDescription = actionFilter.statusDescription.toLowerCase().match(filter)
                    const id = actionFilter.id.toString().match(filter);

                    if(dateRegisterFormatted != null) { return dateRegisterFormatted; } 
                    else if(panelDescription != null) { return panelDescription; } 
                    else if(stageDescription != null) { return stageDescription; } 
                    else if(labelName != null) { return labelName; } 
                    else if(quickAccessMenuDescription != null) { return quickAccessMenuDescription; } 
                    else if(statusDescription != null) { return statusDescription; } 
                    else { return id; }
                });
            }
        },

        methods: {

            getStatusColor (status) {

                let color = "";

                switch (status) {

                    case 1:
                        color = 'var(--color__main)';
                        break;

                    case 0:
                        color = 'var(--color__cinza_escuro)';
                        break;
                
                    default:
                        break;
                }

                return color
            },
            
            async getRegisters() {

                this.listActions = await this.$store.dispatch("actionsModule/List");
            },

            confirmCancel(id) {

                this.statusId = 0;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will INACTIVATE this Action, confirm your decision?',
                    methodConfirm: this.cancel,
                    params: id
                };
            },

            async cancel(id) {

                let statusId = this.statusId;

                this.showLoading();

                let result = await this.$store.dispatch("actionsModule/UpdateStatus", { id, statusId });

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getRegisters();

                this.hideLoading();
            },

            confirmActive(id) {

                this.statusId = 1;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will ACTIVATE this Action, confirm your decision?',
                    methodConfirm: this.active,
                    params: id
                };

            },

            async active(id) {

                this.showLoading();
                let statusId = this.statusId;

                let result = await this.$store.dispatch("actionsModule/UpdateStatus", { id, statusId });

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                await this.getRegisters();

                this.hideLoading();
            },

            async exportExcel() {
                this.exportFileName(this.URL_EXPORT_ACTIONS, null, 'ActionsList.xlsx');
            },

            confirmClone(id) {
                this.$router.push({ name: 'actionsForm', params: { id: id, clone: true } });
            },
        },

        async created() {
            this.showLoading();
            await this.getRegisters();
            this.hideLoading();
        }
    })
</script>
